import React from 'react';
import { Box, } from '@waglabs/box-next';
import { Video, } from '@waglabs/video';
export const IFrameVideoLightboxView = ({ data: { source: src, }, videoProps: { iframeProps, ...restVideoProps } = {}, ...rest }) => (React.createElement(Box, Object.assign({ position: "relative", pb: "56.25%" // 16:9 aspect ratio
    , width: ['320px', '720px', '1080px'] }, rest),
    React.createElement(Video, Object.assign({ src: src, useIframe: true, autoPlay: true, controls: true, height: "auto", width: "100%", iframeProps: {
            id: 'frame',
            frameBorder: '0',
            allowFullScreen: true,
            title: 'Wag! Video',
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            ...iframeProps,
        } }, restVideoProps))));
